import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent implements OnInit {
  slideOpts = {
 
    autoplay: {
    delay: 4000
    }
      };
  constructor() { }

  ngOnInit() {}

}
